import React from 'react';
import { Nav } from 'react-bootstrap';
import styles from './styles.module.scss';

function ListItemComponent(props) {
	return (
		<li onClick={() => props.clicked()} className={styles.listItem}>
			<Nav.Link>
				{/* <div className={props.theClassIWant}> */}
				<div
					className={`${
						props.theClassIWant === 'sideBarItem'
							? styles.sidebarItem
							: styles.activeClass
					}`}
				>
					{/* Text */}
					<div className={styles.sidebarLabel}>
						<span>{props.label}</span>
					</div>

					{/* Icon */}
					<div className={styles.sidebarIcon}>
						<i className={props.iconClass}></i>
					</div>
				</div>
			</Nav.Link>
		</li>
	);
}

export default ListItemComponent;
